import { defineMessages } from "react-intl";

import {
	hlaTypingMessages,
	statusByNephrologistMessages,
	validator
} from "lib/build/forms/ktx/patientCondition";

import { FieldData, FieldListData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientCondition: {
		id: "kd.form.patient_condition.title",
		defaultMessage: "Állapotváltozás jelentés"
	},
	description: {
		id: "kd.form.patient_condition.description",
		defaultMessage: "Megjegyzés"
	},
	statusByNephrologist: {
		id: "kd.form.patient_condition.status_by_nephrologist",
		defaultMessage: "Nefrológus véleménye"
	},
	hlaTyping: {
		id: "kd.form.patient_condition.hla_typing",
		defaultMessage: "HLA Tipizálás"
	}
});

const fields: { [key: string]: FieldData | FieldListData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	statusByNephrologist: {
		type: "field",
		path: ["statusByNephrologist"],
		label: messages.statusByNephrologist,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: {
				labels: statusByNephrologistMessages
			}
		}
	},
	hlaTyping: {
		type: "field",
		path: ["hlaTyping"],
		label: messages.hlaTyping,
		errorMessages: genericErrorMessages,
		input: { type: "checkbox-group", props: { labels: hlaTypingMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.description }] },
		{ columns: [{ width: 12, field: fields.statusByNephrologist }] },
		{ columns: [{ width: 12, field: fields.hlaTyping }] }
	]
};

export const node: LeafNode = {
	id: "ktx_patientCondition",
	value: {
		schemaId: "patientCondition",
		title: messages.patientCondition,
		validator,
		applyCurrentDate: true,
		showTimeInput: true,
		fieldset,
		returnTo: "status-history"
	}
};
